import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-76425848"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "progress__area cms-card-block mg-t--15"
};
const _hoisted_3 = {
  class: "cms-card-block"
};
const _hoisted_4 = {
  class: "btn-operate"
};
import ActionHeader from '@/views/common/ActionHeader/index.vue';
import ProgressLine from '@/views/common/ProgressLine/index.vue';
import FirstStep from './components/FirstStep/index.vue';
import SecondStep from './components/SecondStep/index.vue';
import ThirdStep from './components/ThirdStep/index.vue';
import AddSeriesFilm from '../components/AddSeriesFilm/index.vue';
import { provide } from 'vue';
import { elMessage } from '@/utils';
import { clearData, scrollIntoView } from '@/utils/tools';
import { addProgramSetApi, getProgramSetByIdApi, editProgramSetApi } from '@/api/vodNew';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    detailInfo: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['update:modelValue', 'update-list'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const firstStepRef = ref(null);
    const secondStepRef = ref(null);
    const thirdStepRef = ref(null);
    const isShowAddSeriesFilm = ref(false);
    const titleComputed = computed(() => props.detailInfo.id ? '编辑系列影片' : '新增系列影片'); // 标题配置

    const headerConfig = reactive({
      title: titleComputed,
      btnList: [{
        label: '返回',
        func: () => {
          emit('update:modelValue', false);
          emit('update-list');
          progressData.active = 0;
        }
      }]
    }); // 进度条配置

    const progressData = reactive({
      active: -1,
      data: [{
        title: '基础信息',
        key: 0
      }, {
        title: '添加影片',
        key: 1
      }, {
        title: '关联分类',
        key: 2
      }],
      componentId: '',
      loading: false,
      infoLoading: false
    }); // 数据回显配置

    const data = ref({
      categoryIdList: [],
      id: props.detailInfo.id,
      language: '',
      name: '',
      posters: [],
      otherNameList: [],
      programInfo: [],
      isFirst: true,
      cloudDiskAccountIdList: [],
      childMode: 0,
      categoryType: 'Movies'
    });
    provide('finishData', data); // 上一步按钮点击事件

    const handleLast = () => {
      validatorCurrentActiveDataFn('next', progressData.active - 1);
    }; // 下一步按钮点击事件


    const handleNext = () => {
      validatorCurrentActiveDataFn('next', progressData.active + 1);
    }; // 取消按钮点击事件


    const handleCancel = () => {
      emit('update:modelValue', false);
      progressData.active = 0;
    }; // 完成按钮点击事件


    const handleOk = async () => {
      try {
        progressData.loading = true;
        data.value.categoryIdList = thirdStepRef.value.dataInfo.selectList.map(item => item.id);
        console.log('data.value.programInfo', data.value.programInfo);
        data.value.programInfo = data.value.programInfo.map(item => {
          return {
            programId: item.programId || item.id,
            programType: item.programType,
            sequence: item.sequence
          };
        });
        data.value.name = data.value.name.trim();
        data.value.otherNameList.forEach(item => {
          if (String(item)) {
            item.name = item.name.trim();
          }
        });
        data.value.posters.forEach(item => {
          delete item.file;
        });
        const cid = Number(sessionStorage.getItem('currentCid'));
        const cpspId = Number(sessionStorage.getItem('currentCpspid'));
        let postData = {
          cid,
          cpspId,
          texts: [{
            language: data.value.language,
            name: data.value.name
          }, ...data.value.otherNameList],
          posters: data.value.posters.map(item => {
            return {
              imageUrl: item.url,
              imageBase64: item.imageBase64,
              posterType: item.posterType,
              language: item.language,
              visualType: item.visualType
            };
          }),
          categoryIdList: data.value.categoryIdList,
          programs: data.value.programInfo,
          cloudDiskAccountIdList: data.value.cloudDiskAccountIdList,
          childMode: data.value.childMode,
          categoryType: data.value.categoryType
        };

        if (data.value.id) {
          const res = await editProgramSetApi({ ...postData,
            id: props.detailInfo.id
          });

          if (res.code == '0') {
            elMessage('success', '修改成功');
            emit('update:modelValue', false);
            emit('update-list');
            progressData.loading = false;
          } else {
            progressData.loading = false;
          }
        } else {
          const res = await addProgramSetApi(postData);

          if (res.code == '0') {
            elMessage('success', '新增成功');
            emit('update:modelValue', false);
            emit('update-list');
            progressData.loading = false;
          } else {
            progressData.loading = false;
          }
        }
      } catch (error) {
        progressData.loading = false;
      }
    }; // SecondStep 子组件事件


    const handleAdd = () => {
      isShowAddSeriesFilm.value = true;
    }; // AddSeriesFilm 子组件响应 goBack事件


    const goBack = () => {
      isShowAddSeriesFilm.value = false;
    }; // AddSeriesFilm 子组件响应 addList事件


    const addList = dataList => {
      console.log('dataList', dataList);

      if (secondStepRef.value) {
        dataList.forEach(item => {
          let idx = secondStepRef.value.tableConfig.data.findIndex(tableItem => tableItem.id === item.id);

          if (idx === -1) {
            secondStepRef.value.tableConfig.data.push({ ...item,
              sequence: secondStepRef.value.tableConfig.data.length > 0 ? secondStepRef.value.tableConfig.data[secondStepRef.value.tableConfig.data.length - 1].sequence + 1 : 1
            });
          }
        });
      }

      data.value.programInfo = secondStepRef.value.tableConfig.data;
      isShowAddSeriesFilm.value = false;
    }; // 获取详情


    const getProgramSetById = async () => {
      try {
        progressData.infoLoading = true;
        const res = await getProgramSetByIdApi({
          videoSeriesId: props.detailInfo.id
        });

        if (res.code == '0') {
          data.value = res.data;
          data.value.language = res.data.texts ? res.data.texts[0].language : ''; // 语言用texts的第一项

          data.value.id = props.detailInfo.id;
          data.value.programInfo = []; // data.value.otherNameList = res.data.otherNameList ? res.data.otherNameList : [];

          if (res.data.texts && res.data.texts.length) {
            let copyTexts = JSON.parse(JSON.stringify(res.data.texts));
            copyTexts.shift(); //移除第一项，剩下的就是其他语言

            data.value.otherNameList = copyTexts;
          }

          data.value.categoryIdList = res.data.categoryIdList ? res.data.categoryIdList : [];
          data.value.isFirst = true;
          progressData.infoLoading = false;
        } else {
          progressData.infoLoading = false;
        }

        progressData.infoLoading = false;
      } catch (error) {
        progressData.infoLoading = false;
      }

      progressData.active = 0;
    }; // 步骤条item点击事件


    const onStepClick = stepIndex => {
      validatorCurrentActiveDataFn('step', stepIndex);
    }; // 校验当前步骤数据/保存数据


    const validatorCurrentActiveDataFn = (type, stepIndex) => {
      if (progressData.active === 0) {
        if (stepIndex == progressData.active + 1 || maxStepIndex.value >= stepIndex) {
          Promise.all([firstStepRef.value.formDataRef.validate(), firstStepRef.value.imageItemRef.validate(), firstStepRef.value.androidImageItemRef.validate()]).then(valid => {
            data.value.posters = [...firstStepRef.value.data.coverList, ...firstStepRef.value.data.backgroundList, ...firstStepRef.value.data.androidCoverList, ...firstStepRef.value.data.androidBackgroundList];
            data.value.language = firstStepRef.value.formConfig.formData[0].language;
            data.value.name = firstStepRef.value.formConfig.formData[0].name;
            data.value.cloudDiskAccountIdList = firstStepRef.value.formConfig.otherData.cloudDiskAccountIdList;
            data.value.childMode = firstStepRef.value.formConfig.otherData.childMode;
            data.value.categoryType = firstStepRef.value.formConfig.otherData.categoryType;

            if (firstStepRef.value.formConfig.formData.length > 1) {
              let list = JSON.parse(JSON.stringify(firstStepRef.value.formConfig.formData));
              list.splice(0, 1);
              data.value.otherNameList = list;
            }

            progressData.active = stepIndex;
          }).catch(err => {
            scrollIntoView();
          });
        }
      } else if (progressData.active === 1) {
        if (stepIndex == progressData.active + 1 || maxStepIndex.value >= stepIndex) {
          if (type == 'next' || type == 'step' && stepIndex > progressData.active) {
            if (secondStepRef.value.tableConfig.data.length === 0) return elMessage('warning', '请添加影片');
            data.value.programInfo = secondStepRef.value.tableConfig.data;
            progressData.active = stepIndex;
          } else {
            data.value.programInfo = secondStepRef.value.tableConfig.data;
            progressData.active = stepIndex;
          }
        }
      } else if (progressData.active === 2) {
        data.value.categoryIdList = thirdStepRef.value.dataInfo.selectList.map(item => item.id);
        progressData.active = stepIndex;
      }
    }; // 记录当前最大步骤数


    const maxStepIndex = ref(0);
    watch(() => progressData.active, val => {
      if (val > maxStepIndex.value) {
        maxStepIndex.value = val;
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => props.modelValue, val => {
      if (!val) {
        clearData(data.value);
        progressData.active = -1;
        maxStepIndex.value = 0;
      } else {
        if (props.detailInfo.id) {
          maxStepIndex.value = 2;
          getProgramSetById();
        } else {
          progressData.active = 0;
        }
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _directive_loading = _resolveDirective("loading");

      return __props.modelValue ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", null, [_createVNode(ActionHeader, {
        config: headerConfig
      }, null, 8, ["config"]), _createElementVNode("div", _hoisted_2, [_createVNode(ProgressLine, {
        modelValue: progressData.active,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => progressData.active = $event),
        onOnStepClick: onStepClick,
        progressData: progressData.data
      }, null, 8, ["modelValue", "progressData"])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", null, [progressData.active === 0 ? (_openBlock(), _createBlock(FirstStep, {
        key: 0,
        ref_key: "firstStepRef",
        ref: firstStepRef
      }, null, 512)) : _createCommentVNode("", true), progressData.active === 1 ? (_openBlock(), _createBlock(SecondStep, {
        key: 1,
        ref_key: "secondStepRef",
        ref: secondStepRef,
        onHandleAdd: handleAdd
      }, null, 512)) : _createCommentVNode("", true), progressData.active === 2 ? (_openBlock(), _createBlock(ThirdStep, {
        key: 2,
        ref_key: "thirdStepRef",
        ref: thirdStepRef
      }, null, 512)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [progressData.active === 0 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: "btn-cancel cms-op-btn-non-focus",
        onClick: handleCancel
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('取消')), 1)]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        class: "btn-cancel cms-op-btn-non-focus",
        onClick: handleLast
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('上一步')), 1)]),
        _: 1
      })), progressData.active === 2 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 2,
        class: "btn-confirm",
        onClick: handleOk
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('确定')), 1)]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_button, {
        key: 3,
        class: "btn-confirm cms-op-btn-main",
        onClick: handleNext
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('下一步')), 1)]),
        _: 1
      }))])])), [[_directive_loading, progressData.infoLoading]])], 512), [[_vShow, !isShowAddSeriesFilm.value]]), isShowAddSeriesFilm.value ? (_openBlock(), _createBlock(AddSeriesFilm, {
        key: 0,
        "select-list": data.value.programInfo,
        onGoBack: goBack,
        onAddList: addList
      }, null, 8, ["select-list"])) : _createCommentVNode("", true)])), [[_directive_loading, progressData.loading]]) : _createCommentVNode("", true);
    };
  }

});